<template>
  <section>
    <h1>{{ $t('home.dashboard') }}</h1>
    <section class="box">
      <div class="container info">
        <current-jewel-balance-panel/>
      </div>
      <div class="container history">
        <jewel-history-panel/>
      </div>
    </section>
  </section>
</template>

<style lang="scss" scoped>
@import "../../styles/media_query_mixins.scss";

.box {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  @include size-lg {
    flex-direction: row;
  }

  & > .container {
    margin-bottom: 20px;

    @include size-lg {
      &.info {
        flex-basis: calc(30% - 10px);
      }
      &.history {
        flex-basis: calc(70% - 10px);
      }
    }
  }
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'

import CurrentJewelBalancePanel from './components/CurrentJewelBalancePanel.vue'
import JewelHistoryPanel from './components/JewelHistoryPanel.vue'

export default {
  name: 'index',
  components: {
    CurrentJewelBalancePanel,
    JewelHistoryPanel
  },
  computed: {
    ...mapGetters('session', ['isLoggedIn'])
  },
  mounted () {
    if (!this.isLoggedIn) {
      this.displayAlert({ message: this.$t('home.loginRequired') })
      this.$router.replace('/auth')
    }
  },
  methods: {
    ...mapActions(['displayAlert'])
  }
}
</script>
